import { render, staticRenderFns } from "./ChangeTellThanks.vue?vue&type=template&id=41a9c714&"
import script from "./ChangeTellThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeTellThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports